import { Box } from "grommet";

const GapBox = () => {
    return (
        <Box margin={{ bottom: '0.5rem' }}></Box>
    )
};

export { GapBox };
